// Motor de serialización markdown<->HTML de DoctexHtml.jsx, relocado tal cual — mismo
// comportamiento que tenía
// inline en el componente, sin rediseñar la gramática de tokens (::(pagina(...)),
// ::(database(...)), ::(inlineflow(...)), ::(image(...)), ::(mention(...))). Cubierto por
// docMarkdown.test.js contra ejemplos reales de doccontent.content antes de tocar nada más del
// editor.
export const markdownToHtml = (md) => {
    if (!md) return '';
    let html = md
        // Custom Tokens (DocTag) - Robust Regex
        // Matches ::(pagina([emoji][text][link]))
        .replace(/::\(pagina\(\[(.*?)\]\[(.*?)\]\[(.*?)\]\)\)/g, (match, emoji, text, link) => {
            const e = emoji.trim();
            const t = text.trim();
            const l = link.trim();
            const absoluteUrl = l.startsWith('http') ? l : `${window.location.origin}${l.startsWith('/') ? '' : '/'}${l}`;
            // Simplified structure using CSS class
            return `<a href="${absoluteUrl}" class="doc-tag" contenteditable="false"><span class="doc-tag-emoji">${e}</span><span class="doc-tag-text">${t}</span><span class="copy-url-hidden"> (${absoluteUrl})</span></a>`;
        })
        // External Link Token — el 4to grupo `[color]` es opcional (integración de los avances
        // de main): links creados antes de esa integración no lo tienen, siguen funcionando.
        // La cápsula generada debe calzar exactamente con lo que `htmlToMarkdown` espera para
        // reconocerla de vuelta (clase `doc-tag external`, spans `doc-tag-emoji`/`doc-tag-text`,
        // color inline) y con lo que ya genera a mano DoctexHtml.jsx (dropdown de LilMenu,
        // `hexToRgbStr` + `styleStr`) para que un link se vea igual recién creado o recargado
        // desde el markdown guardado.
        .replace(/::\(external\(\[(.*?)\]\[(.*?)\]\[(.*?)\](?:\[(.*?)\])?\)\)/g, (match, emoji, text, link, color) => {
            const e = emoji.trim();
            const t = text.trim();
            const l = link.trim();
            const c = color ? color.trim() : '';

            let styleAttr = '';
            if (c) {
                const rgbMatch = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(c);
                const rgb = rgbMatch
                    ? `${parseInt(rgbMatch[1], 16)}, ${parseInt(rgbMatch[2], 16)}, ${parseInt(rgbMatch[3], 16)}`
                    : null;
                styleAttr = rgb
                    ? ` style="color: ${c}; background: rgba(${rgb}, 0.15); border: 1px solid rgba(${rgb}, 0.2);"`
                    : ` style="color: ${c}"`;
            }

            return `<a href="${l}" target="_blank" class="doc-tag external" contenteditable="false"${styleAttr}><span class="doc-tag-emoji">${e}</span><span class="doc-tag-text">${t}</span><span class="copy-url-hidden"> (${l})</span></a>`;
        })
        // Database Token
        .replace(/::\(database\(\[(.*?)\]\[(.*?)\]\[(.*?)\]\)\)/g, (match, emoji, text, id) => {
            // Visual Block (Minified, with Chevron Menu)
            return `<div class="doc-database-block" data-id="${id}" contenteditable="false"><div class="header"><div class="name-tag"><span class="tag-emoji">${emoji || '🗄️'}</span><span class="tag-text">${text}</span><button class="copy-uid-btn" title="Copy UID" data-uid="${id}"><svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect width="14" height="14" x="8" y="8" rx="2" ry="2"/><path d="M4 16c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2h10c1.1 0 2 .9 2 2"/></svg></button><button class="chevron-btn"><svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="m6 9 6 6 6-6"/></svg></button><div class="info-dropdown" style="display:none"><div class="info-item"><span class="label">Schema:</span><span class="value">data</span></div><div class="info-item"><span class="label">Table:</span><span class="value">${id}</span></div></div></div><div class="controls"><div class="control-btn" title="Configuración">⚙️</div><div class="search-container"><span class="search-icon">🔍</span><input type="text" class="search-input" placeholder="Buscar..." disabled /></div><div class="control-btn" title="Filtros">🌪️</div></div></div><div class="body">Vista previa del contenido de la tabla...</div></div>`;
        })
        // Inline Flow Token
        .replace(/::\(inlineflow\(\[(.*?)\]\)\)/g, (match, id) => {
            return `<div class="doc-inlineflow-block" data-id="${id}" contenteditable="false"><div class="body">Cargando Inline Flow...</div></div>`;
        })
        // Inline Ops Table
        .replace(/::\(inlineopstable\(\[(.*?)\]\)\)/g, (match, id) => {
            return `<div class="doc-inline-ops-table-block" data-id="${id}" contenteditable="false"><div class="body">Cargando Tabla de Operaciones...</div></div>`;
        })
        // Inline Social Outline
        .replace(/::\(inlinesocialoutline\(\[(.*?)\]\[(.*?)\]\)\)/g, (match, id, encodedState) => {
            const stateAttr = encodedState && encodedState !== 'null' ? ` data-outline-state="${encodedState}"` : '';
            return `<div class="doc-inline-social-outline-block" data-id="${id}"${stateAttr} contenteditable="false"><div class="body">Cargando outline...</div></div>`;
        })
        // Image Token
        .replace(/::\(image\(\[(.*?)\]\[(.*?)\]\)\)/g, (match, src, width) => {
            return `<img class="resizable-img" style="width: ${width}; height: auto; opacity: 1; border: none;" src="${src}" />`;
        })
        // Mention Token
        .replace(/::\(mention\(\[(.*?)\]\[(.*?)\]\[(.*?)\]\)\)/g, (match, uid, name, avatar) => {
            const displayName = name.startsWith('@') ? name : `@${name}`;
            return `<span class="mention-pill" data-uid="${uid}" data-avatar="${avatar}" contenteditable="false"><span class="mention-avatar" style="background-image: url('${avatar}');"></span><span class="mention-name">${displayName}</span></span>`;
        })
        // Checklist Tokens
        .replace(/::\(checklist\(\[ \]?\[(.*?)\]\)\)/g, (match, text) => {
            return `<ul style="list-style: none; margin: 0; padding: 0;"><li class="custom-checklist-item" data-checked="false" style="display: flex; gap: 6px; align-items: flex-start; margin: 0; padding: 0;"><span contenteditable="false" class="custom-checklist-btn" style="cursor: pointer; margin-top: 2px; user-select: none; display: flex; align-items: center;"><svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#bae6fd" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"></circle></svg></span><span class="custom-checklist-text" style="flex: 1; transition: opacity 0.2s;">${text}</span></li></ul>`;
        })
        .replace(/::\(checklist\(\[x\]\[(.*?)\]\)\)/g, (match, text) => {
            return `<ul style="list-style: none; margin: 0; padding: 0;"><li class="custom-checklist-item" data-checked="true" style="display: flex; gap: 6px; align-items: flex-start; margin: 0; padding: 0;"><span contenteditable="false" class="custom-checklist-btn" style="cursor: pointer; margin-top: 2px; user-select: none; display: flex; align-items: center;"><svg width="16" height="16" viewBox="0 0 24 24" fill="#3b82f6" stroke="#3b82f6" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"></circle><path d="M9 12l2 2 4-4" stroke="#fff"></path></svg></span><span class="custom-checklist-text" style="flex: 1; transition: opacity 0.2s; opacity: 0.5;">${text}</span></li></ul>`;
        })
        // Comment Highlight Token — ancla de un comentario del panel lateral a un tramo de
        // texto (ver .claude/plans/tech-debt, integración de comentarios anclados al margen).
        .replace(/::\(highlight\(\[(.*?)\]\[(.*?)\]\)\)/g, (match, id, text) => {
            return `<span class="comment-highlight" data-comment-id="${id}">${text}</span>`;
        })
        .replace(/^### (.*$)/gim, '<h3>$1</h3>')
        .replace(/^## (.*$)/gim, '<h2>$1</h2>')
        .replace(/^# (.*$)/gim, '<h1>$1</h1>')
        .replace(/\*\*(.*?)\*\*/gim, '<b>$1</b>')
        .replace(/\*(.*?)\*/gim, '<i>$1</i>')
        .replace(/^- (.*$)/gim, '<ul><li>$1</li></ul>')
        .replace(/<\/ul>\n*<ul>/gim, '')
        .replace(/<\/ul>\n*<ul style="list-style: none; margin: 0; padding: 0;">/gim, '')
        .replace(/(<\/h[1-3]>|<\/ul>)\n+/gim, '$1')
        .replace(/\n/gim, '<br />');
    return html;
};

export const jsonBlocksToMarkdown = (blocks) => {
    if (!Array.isArray(blocks)) return String(blocks || '');
    return blocks.map(b => {
        let text = b.content || '';
        return text.replace(/<[^>]*>?/gm, '');
    }).join('\n\n');
};

export const htmlToMarkdown = (html) => {
    if (!html) return '';

    // 0. Pre-process using DOMParser
    const parser = new DOMParser();
    const doc = parser.parseFromString(html, 'text/html');

    // A. Protect Columns (and potentially other complex blocks)
    const protectedBlocks = [];
    const colContainers = doc.querySelectorAll('.doc-column-container');
    colContainers.forEach((wc, index) => {
        const token = `::(PROTECTED_BLOCK_${index})`;
        protectedBlocks.push({ token, html: wc.outerHTML });
        wc.replaceWith(document.createTextNode(token));
    });

    // B. Convert DocTags to Tokens
    const docTags = doc.querySelectorAll('a.doc-tag');
    docTags.forEach(tag => {
        const href = tag.getAttribute('href') || '#';
        const emoji = tag.querySelector('.doc-tag-emoji')?.innerText || '📄';
        const text = tag.querySelector('.doc-tag-text')?.innerText || '';

        const safeEmoji = emoji.replace(/[[\]]/g, '');
        const safeText = text.replace(/[[\]]/g, '');
        const safeHref = href.replace(/[[\]]/g, '');

        let token;
        if (tag.classList.contains('external')) {
            // Color de la cápsula (integración de los avances de main) — `style.color` ya
            // viene resuelto por el navegador como `rgb(r, g, b)`, se convierte a hex para
            // guardarlo en el token.
            let hexColor = '';
            const colorRaw = tag.style.color || '';
            if (colorRaw.startsWith('rgb')) {
                const rgbMatch = colorRaw.match(/rgb\((\d+),\s*(\d+),\s*(\d+)\)/);
                if (rgbMatch) {
                    const [, r, g, b] = rgbMatch;
                    hexColor = `#${Number(r).toString(16).padStart(2, '0')}${Number(g).toString(16).padStart(2, '0')}${Number(b).toString(16).padStart(2, '0')}`.toUpperCase();
                }
            } else if (colorRaw.startsWith('#')) {
                hexColor = colorRaw;
            }
            token = hexColor
                ? `::(external([${safeEmoji}][${safeText}][${safeHref}][${hexColor}]))`
                : `::(external([${safeEmoji}][${safeText}][${safeHref}]))`;
        } else {
            let relativeHref = safeHref;
            if (relativeHref.startsWith(window.location.origin)) {
                relativeHref = relativeHref.replace(window.location.origin, '');
            }
            token = `::(pagina([${safeEmoji}][${safeText}][${relativeHref}]))`;
        }

        tag.replaceWith(document.createTextNode(token));
    });

    // C. Convert Checklists to Tokens
    const checklists = doc.querySelectorAll('li.custom-checklist-item');
    checklists.forEach(item => {
        const isChecked = item.getAttribute('data-checked') === 'true';
        const textSpan = item.querySelector('.custom-checklist-text');
        let text = '';
        if (textSpan) {
            text = textSpan.innerHTML; // Preserve inline formatting inside text
        } else {
            // Fallback
            text = item.innerText.trim();
        }
        
        // Escape brackets
        text = text.replace(/\[/g, '&#91;').replace(/\]/g, '&#93;');
        
        const token = isChecked ? `::(checklist([x][${text}]))` : `::(checklist([ ][${text}]))`;
        
        // We replace the entire UL if this is the only LI, or just the LI if there are multiple
        // Actually, replacing the LI with text node is safest, the generic UL remover will strip the UL wrappers later
        item.replaceWith(document.createTextNode(token + '\n'));
    });

    // Convert Database Blocks to Tokens
    const dbBlocks = doc.querySelectorAll('.doc-database-block');
    dbBlocks.forEach(blk => {
        // Try new selectors first, then fallback to old
        const emoji = blk.querySelector('.tag-emoji, .doc-tag-emoji')?.innerText || '🗄️';
        const text = blk.querySelector('.tag-text, .doc-tag-text')?.innerText || '';
        const fullId = blk.getAttribute('data-id') || '';

        const token = `::(database([${emoji}][${text}][${fullId}]))`;
        blk.replaceWith(document.createTextNode(token));
    });

    // Convert Inline Flow Blocks to Tokens
    const inlineFlowBlocks = doc.querySelectorAll('.doc-inlineflow-block');
    inlineFlowBlocks.forEach(blk => {
        const fullId = blk.getAttribute('data-id') || 'flow';
        const token = `::(inlineflow([${fullId}]))`;
        blk.replaceWith(document.createTextNode(token));
    });

    // Convert Inline Ops Table to Tokens
    const inlineOpsTableBlocks = doc.querySelectorAll('.doc-inline-ops-table-block');
    inlineOpsTableBlocks.forEach(blk => {
        const fullId = blk.getAttribute('data-id') || 'ops';
        const token = `::(inlineopstable([${fullId}]))`;
        blk.replaceWith(document.createTextNode(token));
    });

    // Convert Inline Social Outline to Tokens
    const inlineSocialOutlineBlocks = doc.querySelectorAll('.doc-inline-social-outline-block');
    inlineSocialOutlineBlocks.forEach(blk => {
        const fullId = blk.getAttribute('data-id') || 'social-outline';
        const encodedState = blk.getAttribute('data-outline-state') || 'null';
        const token = `::(inlinesocialoutline([${fullId}][${encodedState}]))`;
        blk.replaceWith(document.createTextNode(token));
    });

    // D. Convert Mentions to Tokens
    const mentions = doc.querySelectorAll('span.mention-pill');
    mentions.forEach(mention => {
        const uid = mention.getAttribute('data-uid') || '';
        const nameNode = mention.querySelector('.mention-name');
        // El `@` es solo de despliegue -- `markdownToHtml` lo antepone él mismo si hace falta
        // (línea ~70). Si se guarda acá también, cada ida y vuelta agrega otro `@` (bug real,
        // corrompía el nombre guardado en el primer re-guardado de un doc con una mención).
        const rawName = nameNode ? nameNode.textContent.trim() : (mention.textContent || '').trim();
        const name = rawName.startsWith('@') ? rawName.slice(1) : rawName;
        const avatar = mention.getAttribute('data-avatar') || (mention.querySelector('img') ? mention.querySelector('img').getAttribute('src') : '');
        const token = `::(mention([${uid}][${name}][${avatar}]))`;
        mention.replaceWith(document.createTextNode(token));
    });

    // E. Convert Comment Highlights to Tokens
    const commentHighlights = doc.querySelectorAll('span.comment-highlight');
    commentHighlights.forEach(span => {
        const id = span.getAttribute('data-comment-id') || '';
        const text = span.innerHTML || '';
        const token = `::(highlight([${id}][${text}]))`;
        span.replaceWith(document.createTextNode(token));
    });

    let processedHtml = doc.body.innerHTML;

    // Strip all native newlines to avoid regex matching issues, relying on block elements for layout
    processedHtml = processedHtml.replace(/[\r\n]+/g, ' ');

    // 1. Convert Images to Tokens
    processedHtml = processedHtml.replace(/<img[^>]*src=["']([^"']+)["'][^>]*>/gi, (match, src) => {
        let widthMatch = match.match(/width:\s*([^;]+);/i);
        let width = widthMatch ? widthMatch[1].trim() : '100%';
        return `::(image([${src}][${width}]))`;
    });

    // 2. Normalize block containers to newlines (handle div, p, br)
    let md = processedHtml
        .replace(/<div[^>]*>/gi, '\n')
        .replace(/<\/div>/gi, '')
        .replace(/<p[^>]*>/gi, '\n')
        .replace(/<\/p>/gi, '')
        .replace(/<br\s*\/?>/gi, '\n');

    // 3. Headings
    md = md.replace(/<h1[^>]*>([\s\S]*?)<\/h1>/gi, (m, p1) => `# ${p1.trim().replace(/\n/g, '<br />')}\n`);
    md = md.replace(/<h2[^>]*>([\s\S]*?)<\/h2>/gi, (m, p1) => `## ${p1.trim().replace(/\n/g, '<br />')}\n`);
    md = md.replace(/<h3[^>]*>([\s\S]*?)<\/h3>/gi, (m, p1) => `### ${p1.trim().replace(/\n/g, '<br />')}\n`);

    // 4. Inline styles
    md = md.replace(/<b[^>]*>([\s\S]*?)<\/b>/gi, '**$1**');
    md = md.replace(/<strong[^>]*>([\s\S]*?)<\/strong>/gi, '**$1**');
    md = md.replace(/<i[^>]*>([\s\S]*?)<\/i>/gi, '*$1*');
    md = md.replace(/<em[^>]*>([\s\S]*?)<\/em>/gi, '*$1*');

    // 5. Lists
    md = md.replace(/<li[^>]*>([\s\S]*?)<\/li>/gi, (m, p1) => `- ${p1.trim().replace(/\n/g, '<br />')}\n`);
    md = md.replace(/<\/?ul[^>]*>/gi, '');

    // 6. Clean up HTML entities
    md = md.replace(/&nbsp;/g, ' ');
    md = md.replace(/&lt;/g, '<').replace(/&gt;/g, '>').replace(/&amp;/g, '&');

    // C. Restore Protected Blocks
    protectedBlocks.forEach(pb => {
        md = md.replace(pb.token, pb.html);
    });

    return md.trim();
};
